import { Injectable } from "@angular/core";
import {
  HttpClient
} from "@angular/common/http";
import { StatesModel } from "@shared/models/states.model";
import { of } from "rxjs";
import { AppConfig } from "@appconfig";
import { AuthService } from "@services/auth.service";
import { HttpRepo } from "@shared/services/httprepo";
import { ApiEndPointType } from "@shared/enums/common";
import { CodeTypeModel } from "@fs/models/code-type.model";

@Injectable()
export class CommonService {
  public states: StatesModel[] = [];
  constructor(
    private http: HttpClient,
    private appConfig: AppConfig,
    private httpRepo: HttpRepo,
    private auth: AuthService
  ) {}

  GetStates() {
    return of([
      {
        StateName: "Alabama",
        StateCode: "AL"
      },
      {
        StateName: "Alaska",
        StateCode: "AK"
      },
      {
        StateName: "American Samoa",
        StateCode: "AS"
      },
      {
        StateName: "Arizona",
        StateCode: "AZ"
      },
      {
        StateName: "Arkansas",
        StateCode: "AR"
      },
      {
        StateName: "California",
        StateCode: "CA"
      },
      {
        StateName: "Colorado",
        StateCode: "CO"
      },
      {
        StateName: "Connecticut",
        StateCode: "CT"
      },
      {
        StateName: "Delaware",
        StateCode: "DE"
      },
      {
        StateName: "District Of Columbia",
        StateCode: "DC"
      },
      {
        StateName: "Federated States Of Micronesia",
        StateCode: "FM"
      },
      {
        StateName: "Florida",
        StateCode: "FL"
      },
      {
        StateName: "Georgia",
        StateCode: "GA"
      },
      {
        StateName: "Guam",
        StateCode: "GU"
      },
      {
        StateName: "Hawaii",
        StateCode: "HI"
      },
      {
        StateName: "Idaho",
        StateCode: "ID"
      },
      {
        StateName: "Illinois",
        StateCode: "IL"
      },
      {
        StateName: "Indiana",
        StateCode: "IN"
      },
      {
        StateName: "Iowa",
        StateCode: "IA"
      },
      {
        StateName: "Kansas",
        StateCode: "KS"
      },
      {
        StateName: "Kentucky",
        StateCode: "KY"
      },
      {
        StateName: "Louisiana",
        StateCode: "LA"
      },
      {
        StateName: "Maine",
        StateCode: "ME"
      },
      {
        StateName: "Marshall Islands",
        StateCode: "MH"
      },
      {
        StateName: "Maryland",
        StateCode: "MD"
      },
      {
        StateName: "Massachusetts",
        StateCode: "MA"
      },
      {
        StateName: "Michigan",
        StateCode: "MI"
      },
      {
        StateName: "Minnesota",
        StateCode: "MN"
      },
      {
        StateName: "Mississippi",
        StateCode: "MS"
      },
      {
        StateName: "Missouri",
        StateCode: "MO"
      },
      {
        StateName: "Montana",
        StateCode: "MT"
      },
      {
        StateName: "Nebraska",
        StateCode: "NE"
      },
      {
        StateName: "Nevada",
        StateCode: "NV"
      },
      {
        StateName: "New Hampshire",
        StateCode: "NH"
      },
      {
        StateName: "New Jersey",
        StateCode: "NJ"
      },
      {
        StateName: "New Mexico",
        StateCode: "NM"
      },
      {
        StateName: "New York",
        StateCode: "NY"
      },
      {
        StateName: "North Carolina",
        StateCode: "NC"
      },
      {
        StateName: "North Dakota",
        StateCode: "ND"
      },
      {
        StateName: "Northern Mariana Islands",
        StateCode: "MP"
      },
      {
        StateName: "Ohio",
        StateCode: "OH"
      },
      {
        StateName: "Oklahoma",
        StateCode: "OK"
      },
      {
        StateName: "Oregon",
        StateCode: "OR"
      },
      {
        StateName: "Palau",
        StateCode: "PW"
      },
      {
        StateName: "Pennsylvania",
        StateCode: "PA"
      },
      {
        StateName: "Puerto Rico",
        StateCode: "PR"
      },
      {
        StateName: "Rhode Island",
        StateCode: "RI"
      },
      {
        StateName: "South Carolina",
        StateCode: "SC"
      },
      {
        StateName: "South Dakota",
        StateCode: "SD"
      },
      {
        StateName: "Tennessee",
        StateCode: "TN"
      },
      {
        StateName: "Texas",
        StateCode: "TX"
      },
      {
        StateName: "Utah",
        StateCode: "UT"
      },
      {
        StateName: "Vermont",
        StateCode: "VT"
      },
      {
        StateName: "Virgin Islands",
        StateCode: "VI"
      },
      {
        StateName: "Virginia",
        StateCode: "VA"
      },
      {
        StateName: "Washington",
        StateCode: "WA"
      },
      {
        StateName: "West Virginia",
        StateCode: "WV"
      },
      {
        StateName: "Wisconsin",
        StateCode: "WI"
      },
      {
        StateName: "Wyoming",
        StateCode: "WY"
      }
    ]);
  }
  GetIntialData(companyId, references: string) {
    this.httpRepo.setAbsoluteUrl(companyId, ApiEndPointType.FS);
    return this.httpRepo.GetReferences("?references=" + references);
  }
  GetTechnicianData(companyId, references: string){
    this.httpRepo.setAbsoluteUrl(companyId, ApiEndPointType.FS);
    return this.httpRepo.Get("users?take=-1&skip=0&filter=[{'field':'Privilege','operator': 'eq','value': 'Adm_FieldService_Mobile_Technician'}]&references="+references);
  }
  GetKPIData(options: any) {
    this.httpRepo.setAbsoluteUrl(this.auth.getCompanyId(), ApiEndPointType.FS);
    return this.httpRepo.Get("reports/companykpis?DateFrom=" + options.dateFrom + "&DateTo=" + options.dateTo + "&RefreshFlagName=" + options.type);
  }
  getTaxGroup(taxGroupId) {
    return this.httpRepo.Get("taxgroups/" + taxGroupId + "/taxcodes");
  }
  GetTechPerfomanceGraphResultSet(data: any){
    let returnData = { data: [], totalOrders: 0, avgOrders: 0};
    data.forEach(x => {
      returnData.data.push({"id":1,"name":x.TechnicianName,"type":"Total Order","value":x.ToatalAmount,"color":"#1B75BB"});
      returnData.data.push({"id":2,"name":x.TechnicianName,"type":"Average Order","value":x.AvgAmount,"color":"#9D9D9D"});
      returnData.totalOrders+=x.ToatalAmount;
      returnData.avgOrders+=x.AvgAmount;
    });
    return returnData;
  }
  GetTotalOrderGraphResultSet(totalOrders: number, avgOrders: number) {
    return [
      {
        Key: "Total Orders",
        Value: totalOrders.toFixed(2),
        Color : '#1B75BB'
      },
      {
        Key: "Average Orders",
        Value: avgOrders.toFixed(2),
        Color:'#9D9D9D'
      },
      {
        Key: "dummy",
        Value: (totalOrders + avgOrders).toFixed(2),
        dummy: true
      }
    ];
  }
  // Temp fix
  GetCandianStates() {
    return of([
      {
      StateName: 'Alberta',
      StateCode: 'AB'
      }, 
      {
        StateName: 'British Columbia',
        StateCode: 'BC'
      }, 
      {
        StateName: 'Manitoba',
        StateCode: 'MB'
      },
      {
        StateName: 'New Brunswick',
        StateCode: 'NB'
      },
      {
        StateName: 'Newfoundland And Labrador',
        StateCode: 'NL'
      },
      {
        StateName: 'Northwest Territories',
        StateCode: 'NT'
      }, 
      {
        StateName: 'Nunavut',
        StateCode: 'NU'
      },
      {
        StateName: 'Ontario',
        StateCode: 'ON'
      },
      {
        StateName: 'Prince Edward Island',
        StateCode: 'PE'
      },   
      {
        StateName: 'Quebec',
        StateCode: 'QC'
      },
      {
        StateName: 'Saskatchewan',
        StateCode: 'SK'
      },
      {
        StateName: 'Yukon',
        StateCode: 'YT'
      },
    ])
  }
}
